import React from 'react'

const VpaDashboard = () => {
  return (
    <div>VpaDashboard</div>
  )
}

export default VpaDashboard